// The desktop tags the agent's own channel 'me'; everything else is the other
// side of the call. Both sockets carry the same `{ transcript, side }` shape.
export const AGENT_SIDE = 0
export const CUSTOMER_SIDE = 1

export const formatTranscriptUtterance = ({ transcript, side, seq } = {}) => ({
  text: transcript || '',
  side: side === 'me' ? AGENT_SIDE : CUSTOMER_SIDE,
  // The wire carries no timestamp, so the moment of arrival is the best we have.
  // Backfilled lines therefore all read as "now" — they are context, not a log.
  time: new Date(),
  // Monotonic per agent; the reducer uses a jump to spot a dropped line.
  seq,
})
